import PlatformActions from './PlatformActions'

export default class COMBOActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'Prosperous Tiger',
      gameCode: 'COMBO-SLOT-001',
      platform: 'COMBO',
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      updateTime,
      jackpotWinAmount,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId, // d84464ea-b26c-411b-a80d-e384ff5e2bac
      roundId: txnId, // d84464ea-b26c-411b-a80d-e384ff5e2bac
      betType: null,
      currency,
      betTime, // 2025-06-06T14:38:07.625+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: jackpotWinAmount ?? 0,
      updateTime, // 2025-06-06T14:38:07.681+08:00
      gameInfo: {
        freeGameCount: 0,
        isFreeGame: false,
        isBuyFreespin: false,
      },
      requireAmount: betAmount,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId,
      updateTime,
      betAmount,
      gameInfo: {
        freeGameCount: 0,
        isFreeGame: false,
        isBuyFreespin: false,
      },
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }
}
